import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation, Navigate } from "react-router-dom";
import { useEffect } from "react";
import ButteredHome from "./screens/Buttered/ButteredHome";
import ButteredFoodItems from "./screens/Buttered/Menu/Buttered_Food_Items";
import ButteredReservation from "./screens/Buttered/Menu/Buttered_Reservation";
import ButteredAbout from "./screens/Buttered/Menu/Buttered_About";
import Butteredwholesale from "./screens/Buttered/Menu/Butteredwholesale";
import DeliveryStart from "./delivery/delivery_start";
import DeliveryMain from "./delivery/delivery_main";
import DeliveryList from "./delivery/delivery_list";
import DeliveryLogin from "./delivery/delivery_login";

// Shim to redirect hash-based URLs to clean URLs
function HashShim() {
  const navigate = useNavigate();
  useEffect(() => {
    const h = window.location.hash;
    if (h && h.startsWith("#/")) {
      navigate(h.slice(1), { replace: true });
    }
    // No dependencies: only on mount
    // eslint-disable-next-line
  }, []);
  return null;
}

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return null;
}

function App() {
  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <Router>
        <HashShim />
        <ScrollToTop />
        <div style={{ flex: 1 }}>
          <Routes>
            <Route path="/" element={<ButteredHome />} />
            <Route path="/mainmenu" element={<ButteredFoodItems />} />
            <Route path="/about" element={<ButteredAbout />} />
            <Route path="/reservation" element={<ButteredReservation />} />
            <Route path="/butteredwholesale" element={<Butteredwholesale />} />
            <Route path="/About" element={<Navigate to="/about" replace />} />
            <Route path="/MainMenu" element={<Navigate to="/mainmenu" replace />} />
            <Route path="/Reservation" element={<Navigate to="/reservation" replace />} />
            <Route path="/Butteredwholesale" element={<Navigate to="/butteredwholesale" replace />} />
            <Route path="/delivery/start" element={<DeliveryStart />} />
            <Route path="/delivery/main" element={<DeliveryMain />} />
            <Route path="/delivery/list" element={<DeliveryList />} />
            <Route path="/delivery/login" element={<DeliveryLogin />} />
          </Routes>
        </div>
      </Router>
    </div>
  );
}

export default App;
